import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAppSelector } from '../store';

interface DriverRouteProps {
  children: React.ReactNode;
}

const DriverRoute: React.FC<DriverRouteProps> = ({ children }) => {
  const { user, userInfo, loading } = useAppSelector((state) => state.auth);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user || (userInfo?.accountType !== 'driver' && userInfo?.accountType !== 'owner')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default DriverRoute; 